import React from 'react';

const newsItems = [
  {
    date: '27 November 2025',
    title: 'New feature: external live listener counter',
    paragraphs: [
      'We added a new option for stations — an external live listener counter that you can embed into any website, widget, or player.',
      'Connecting it is super simple: on the Live Service page click the “Get public counter link” button and the system will automatically email you a personal integration link.',
      'The counter fits any design because it only returns the numeric listener value while the visual layer remains entirely on your side.',
      'The feature is already available to every user.'
    ]
  },
  {
    date: '24 November 2025',
    title: 'TOP: refreshed music charts for radio stations',
    paragraphs: [
      'We updated the music rankings service — now it is called TOP.',
      "What's new and improved:",
      'Only music tracks. TOP counts only the real songs that aired, so the stats reflect the rotation as accurately as possible.',
      'Flexible chart size. Every station can choose exactly the ranking it needs: TOP-10, TOP-20, TOP-40, TOP-50, TOP-100 — or any other value within that range. It is handy both for internal programming and for preparing reports for rightsholders and advertisers.',
      'Exports respect TOP-N. The selected ranking size automatically applies to exports: download PDF or Excel with the same TOP-N you see on the screen.',
      'TOP is already live in the cabinet — just pick a month, set the desired ranking size and build the report.',
      'To use TOP, the station needs to provide playlist exports.'
    ]
  },
  {
    date: '20 November 2025',
    title: 'New metric in Radiomonitor: Average Daily Reach (ADR)',
    paragraphs: [
      'We added a new metric to Radiomonitor — Average Daily Reach (ADR). It shows how many unique listeners arrive on your station within any selected window (1 day, 7 days, 1 month, etc.).',
      'ADR helps you see the real reach of the station for the chosen period, understand how many listeners you actually attract, and speak to advertisers and partners with a clear, trusted reach number.',
      'The ADR metric is useful for station owners, commercial directors, program directors and marketers who handle ad campaigns and grow the station.'
    ]
  },
  {
    date: '17 October 2025',
    title: 'New AHA service — weekday listening profile',
    paragraphs: [
      'We shipped the AHA (Average Hourly Audience) module that builds a weekday listening profile and shows how the average audience changes hour by hour.',
      'For every weekday the system calculates an hourly average, aggregating all matching days inside the selected period.',
      'The view provides both a line chart and a heatmap table.'
    ]
  },
  {
    date: '16 October 2025',
    title: 'Peak loads methodology update',
    paragraphs: [
      'The calculation method in the “Peak loads” service (Statistics section) has been revised.',
      'Weekly and monthly charts now highlight the real peak of simultaneous connections.'
    ]
  },
  {
    date: '15 February 2025',
    title: 'Updated analytics cabinet is live',
    paragraphs: [
      'We rebuilt the “User cabinet” section from scratch. Key metrics are grouped by themes and load instantly thanks to cached API queries.',
      'The layout is tablet-friendly, so your team can monitor live stats on the go.'
    ]
  },
  {
    date: '28 January 2025',
    title: 'Silence monitoring gains precision',
    paragraphs: [
      'Automatic loudness calibration now runs for every stream. The system analyses historical data and adjusts trigger thresholds without manual tweaking.',
      'A new report with markers highlights each incident with timestamps, duration and source for faster investigation.'
    ]
  },
  {
    date: '10 December 2024',
    title: 'Push notifications beta',
    paragraphs: [
      'Browser push notifications are available in beta for stats and stream events. Enable them inside the cabinet to start receiving alerts.',
      'We welcome your feedback — drop us a line at support@radiomonitor.net.'
    ]
  }
];

export default function NewsPageEn({ onSubscribeClick }) {
  return (
    <div
      style={{
        maxWidth: 880,
        margin: '0 auto',
        padding: '40px 24px 80px',
        lineHeight: 1.6,
        color: '#1b1b1f'
      }}
    >
      <h1 style={{ marginBottom: 24, color: '#006e45' }}>Radiomonitor.net news</h1>
      <div
        style={{
          marginBottom: 32,
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: 16
        }}
      >
        <p style={{ margin: 0, flex: '1 1 320px', lineHeight: 1.6 }}>
          Follow platform updates, service improvements and near-term roadmaps in one place.
        </p>
        <button
          type="button"
          onClick={() => onSubscribeClick?.()}
          style={{
            padding: '12px 20px',
            borderRadius: 12,
            border: 'none',
            background: '#006e45',
            color: '#fff',
            fontSize: 16,
            fontWeight: 700,
            cursor: 'pointer',
            flex: '0 0 auto'
          }}
        >
          Subscribe to news
        </button>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 28 }}>
        {newsItems.map((item) => (
          <article key={item.title}>
            <div style={{ fontSize: 13, fontWeight: 600, color: '#4a7f6b', textTransform: 'uppercase' }}>
              {item.date}
            </div>
            <h2 style={{ margin: '8px 0 16px', color: '#134b37', fontSize: 24 }}>
              {item.title}
            </h2>
            {item.paragraphs.map((text, idx) => (
              <p key={idx} style={{ marginBottom: 16 }}>
                {text}
              </p>
            ))}
          </article>
        ))}
      </div>
    </div>
  );
}
